import { GetterTree } from "vuex";
import { State } from "@/typings/store/index";
import { StateMails } from "@/typings/store/plugins/easyFirestore/mail";

const getters: GetterTree<StateMails, State> = {
  get(state) {
    return state.all;
  },
  getArray(state) {
    return Object.values(state.all);
  },
};

const mail = {
  firestorePath: "mail",
  firestoreRefType: "collection",
  moduleName: "mail",
  statePropName: "all",
  namespaced: true,
  state: {},
  getters,
  mutations: {},
  actions: {},
};

export default mail;
